import { Color } from './color';
/**
 * ◆
 */
export const Diamond = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill', symbol: 'diamond' }, options), context);
};
Diamond.props = Object.assign({ defaultMarker: 'diamond' }, Color.props);
//# sourceMappingURL=diamond.js.map